import { BinaryInstances } from '../const';

export const binaryInstance = {
  type: 'string',
  enum: Object.values(BinaryInstances),
};
